export const series = (data, label) => [
  {
    name: label,
    data: data.map(val => val.value),
  },
];
